import { Button, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

import {
  MelcoModelsPermissionsSubListItem,
  MelcoModelsUserProductPermissions,
  useConfirm,
} from "melco-shared-logic";
import { useUserProductRolesAssign } from "../../hooks/users/useUserProductRolesAssign";
import { ADMIN, CUSTOM } from "../../helper/usersHelper";

type UserRoleAssignActionButtonProps = {
  userIdToAssignUpdateProductRolePermissions: string;
  localPermissions: Array<MelcoModelsPermissionsSubListItem> | undefined;
  allRolesResponseObj: MelcoModelsUserProductPermissions | undefined;
  roleType?: any;
};

export const UserRoleAssignActionButton: React.FC<
  UserRoleAssignActionButtonProps
> = ({
  roleType,
  allRolesResponseObj,
  localPermissions,
  userIdToAssignUpdateProductRolePermissions,
  // localPermissions
}) => {
  const { t } = useTranslation();

  const userProductAssignRole = useUserProductRolesAssign(
    userIdToAssignUpdateProductRolePermissions
  );

  const confirmAssignRole = useConfirm(
    async () => {
      let payload = allRolesResponseObj;

      if (
        roleType &&
        roleType[0] &&
        roleType[0].code == CUSTOM &&
        payload &&
        payload.user_product_access
      ) {
        payload.user_product_access[0].permissions = localPermissions;
        payload.role = roleType[0];
      }
      if (
        roleType &&
        roleType[0] &&
        roleType[0].code == ADMIN &&
        payload &&
        payload.role
      ) {
        // When role is ADMIN , permissions data doesn't matter as backend assigns all the permissions
        payload.role = roleType[0];
      }

      const response = await userProductAssignRole({
        melcoModelsUserProductPermissions: payload,
      });
    },
    {
      translationPrefix: "users.tabs.permissions.actions.assignrole",
    }
  );

  return (
    <>
      <div>
        {" "}
        {
          <Button
            icon={<SaveIcon />}
            type="primary"
            onClick={() => {
              confirmAssignRole();
            }}
          >
            {t("users.tabs.permissions.save")}
          </Button>
        }
        {}
      </div>
    </>
  );
};
